import {
  faAddressBook,
  faBuilding,
  faCalendar,
  faClock,
  faCoins,
  faEdit,
  faEnvelope,
  faGlobe,
  faLanguage,
  faMoon,
  faPencilAlt,
  faPhone,
  faSave,
  faStopwatch,
} from "@fortawesome/fontawesome-free-solid";
import { faClose, faGear, faRoute } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/b2b/Modal";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";

const editSettngs = {
  bookingTimeFrame: false,
  nightSearch: false,
  emergencyConatct: false,
};

const Settings = () => {
  const dispatch = useDispatch();
  const initialState = {
    companyDetails: true,
    generalSettings: false,
  };
  const [header, setHeader] = useState(initialState);
  const { token, user } = useSelector((state) => state.auth);
  const { allCompany } = useSelector((state) => state.company);
  const { settings } = useSelector((state) => state.settings);

  // states
  const [company, setCompany] = useState();
  const [companySettingsEdit, setcompanySettingsEdit] = useState(editSettngs);

  // refs
  const bookingTimeFrameRef = useRef();
  const nightSearchRef = useRef();
  const emergencyConatctOneRef = useRef(settings?.emergencyContact1);
  const emergencyConatctTwoRef = useRef(settings?.emergencyContact2);
  const emergencyConatctThreeRef = useRef(settings?.emergencyContact3);

  const [emergencyContact, setemergencyContact] = useState({
    emergencyContactOne: "",
    emergencyContactTwo: "",
    emergencyContactThree: "",
  });

  useEffect(() => {
    dispatch({
      type: "GET_ALL_COMPANY",
      payload: { token },
    });
  }, []);

  useEffect(() => {
    allCompany.forEach((company) => {
      company?.users?.forEach((companyuser) => {
        if (companyuser?.userName === user?.userName) {
          setCompany(company);
        }
      });
    });
  }, [allCompany, user]);

  return (
    <div className="h-screen w-screen fixed ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen">
          <div className="h-16 py-2 border border-b-[1px]">
            {/* <div className="h-16 py-2 text-xl text-[#fb4156] font-semibold">
              Settings
            </div> */}
            {companySettingsEdit.bookingTimeFrame &&
              companySettingsEdit.nightSearch && (
                <div className="animate__animated animate__fadeIn cursor-pointer hover:text-[#fb4156] item-center justify-center pr-20 space-x-4 text-right">
                  <div className="text-right">
                    <FontAwesomeIcon
                      onClick={() => {
                        dispatch({
                          type: "EDIT_COMPANY_SETTINGS",
                          payload: {
                            token,
                            id: company._id,
                            body: {
                              timeFormat: bookingTimeFrameRef.current.value,
                              nightSearchPrice: nightSearchRef.current.value,
                            },
                          },
                        });
                      }}
                      icon={faSave}
                      className="w-4 h-4 mr-4"
                    />
                  </div>
                  <div className="text-sm">Save All</div>
                </div>
              )}
          </div>
          <div className="h-screen w-full">
            <div className="my-5 mx-6 h-[560px] sm:h-[540px] 2md:h-[430px] overflow-y-auto border border-gray-300 rounded-md">
              <div className="text-lg text-black font-semibold font-body bg-gray-200 px-3 py-2">
                Company Details
              </div>
              {/* company Details */}
              <div className="pt-5">
                <div className="sm:space-y-3 px-3 md:px-5">
                  <div className="space-y-5 2md:space-y-0 2md:flex 2md:space-x-20">
                    <div className="w-full md:w-2/5">
                      <SettingsItem
                        icon={faBuilding}
                        label="Company Name"
                        itemText={settings?.companyName}
                      />
                    </div>
                    <div className="w-full md:w-2/5">
                      <SettingsItem
                        icon={faGlobe}
                        label="Website"
                        itemText={settings?.companyWebsite}
                      />
                    </div>
                  </div>
                  <div className="space-y-5 2md:space-y-0 2md:flex 2md:space-x-20 pt-3 2md:mt-0">
                    <div className="w-full md:w-2/5">
                      <SettingsItem
                        icon={faEnvelope}
                        label="Email"
                        itemText={settings?.companyEmail}
                      />
                    </div>
                    <div className="w-full sm:w-2/5">
                      <SettingsItem
                        icon={faAddressBook}
                        label="Contact Number"
                        itemText={settings?.companyPhone}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-lg text-black font-semibold mt-10 2dm:mt-16 font-body bg-gray-200 px-3 py-2">
                General Settings
              </div>
              {/* company Details */}
              <div className="py-5">
                <div className="sm:space-y-3 px-3 md:px-5">
                  <div className="space-y-5 md:space-y-0 md:flex md:space-x-20">
                    <div className="w-full md:w-2/5">
                      <SettingsItem
                        icon={faLanguage}
                        label="Language"
                        itemText={settings?.language}
                      />
                    </div>
                    <div className="w-full md:w-2/5">
                      <SettingsItem
                        icon={faCoins}
                        label="Currency"
                        itemText={settings?.currency}
                      />
                    </div>
                  </div>
                  <div className="pt-1 flex sm:space-y-5 space-x-1">
                    <div className="flex space-y-0 space-x-2 items-center">
                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faStopwatch}
                          className="w-5 text-gray-400"
                        />
                        <div className="text-sm w-36 text-black font-bold font-body">
                          Booking Time Frame
                        </div>
                      </div>
                      {!companySettingsEdit?.bookingTimeFrame ? (
                        <>
                          <div className="text-sm font-semibold font-body">
                            {settings?.bookingTimeFrame}
                          </div>
                          <div>
                            <FontAwesomeIcon
                              className="text-gray-400 cursor-pointer"
                              icon={faPencilAlt}
                              onClick={() => {
                                setcompanySettingsEdit({
                                  ...companySettingsEdit,
                                  bookingTimeFrame: true,
                                });
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <div className="flex space-x-2 ml-4 sm:ml-0">
                              <input
                                ref={bookingTimeFrameRef}
                                className="border-b border-primary textField text-sm font-body"
                                placeholder="Add Booking Time"
                              />
                              <div className="flex space-x-5">
                                <FontAwesomeIcon
                                  className="cursor-pointer text-red-500"
                                  tool
                                  icon={faClose}
                                  onClick={() => {
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      bookingTimeFrame: false,
                                    });
                                  }}
                                />
                                <FontAwesomeIcon
                                  className="cursor-pointer text-green-600"
                                  icon={faSave}
                                  onClick={() => {
                                    dispatch({
                                      type: "UPDATE_SETTINGS",
                                      payload: {
                                        body: {
                                          bookingTimeFrame:
                                            bookingTimeFrameRef.current.value,
                                        },
                                      },
                                    });
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      bookingTimeFrame: false,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="flex space-x-2 mt-3 sm:mt-0">
                    <div className="flex space-x-2 items-center space-y-0">
                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faMoon}
                          className="w-5 text-gray-400"
                        />
                        <div className="text-sm w-36 text-black font-bold font-body">
                          Night Price:{" "}
                        </div>
                      </div>
                      {!companySettingsEdit?.nightSearch ? (
                        <>
                          <div className="text-sm font-semibold font-body">
                            {settings?.nightPrice}
                          </div>
                          <div>
                            <FontAwesomeIcon
                              className="text-gray-400 cursor-pointer"
                              icon={faPencilAlt}
                              onClick={() => {
                                setcompanySettingsEdit({
                                  ...companySettingsEdit,
                                  nightSearch: true,
                                });
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <div className="flex space-x-2 ml-4 sm:ml-0">
                              <input
                                ref={nightSearchRef}
                                onChange={() => {}}
                                className="border-b border-primary text-black textField text-sm"
                                placeholder="Add Night Search Price"
                              />
                              <div className="flex space-x-5">
                                <FontAwesomeIcon
                                  className="cursor-pointer text-red-500"
                                  tool
                                  icon={faClose}
                                  onClick={() => {
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      nightSearch: false,
                                    });
                                  }}
                                />
                                <FontAwesomeIcon
                                  className="cursor-pointer text-green-600"
                                  icon={faSave}
                                  onClick={() => {
                                    dispatch({
                                      type: "UPDATE_SETTINGS",
                                      payload: {
                                        body: {
                                          nightPrice:
                                            nightSearchRef.current.value,
                                        },
                                      },
                                    });
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      nightSearch: false,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className=" mt-3 sm:mt-0 flex space-x-2">
                    <div className="2lg:flex space-x-2 items-center space-y-3 2lg:space-y-0">
                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faPhone}
                          className="w-5 text-gray-400"
                        />
                        <div className="text-sm w-36 font-bold font-body">
                          Emergency Contact:{" "}
                        </div>
                      </div>
                      {!companySettingsEdit?.emergencyConatct ? (
                        <>
                          <div className="sm:flex sm:space-x-6 space-y-3 sm:space-y-0 items-center pl-5 sm:pl-0">
                            <div className="text-sm text-black font-body">
                              {settings?.emergencyContact1},
                            </div>
                            <div className="text-sm text-black font-body">
                              {settings?.emergencyContact2},
                            </div>
                            <div className="text-sm text-black font-body">
                              {settings?.emergencyContact3}
                            </div>
                            <button className="flex space-x-2 items-center bg-secondary text-white font-normal px-3 py-1 rounded-md">
                              <FontAwesomeIcon
                                className="text-white cursor-pointer h-3.5"
                                icon={faPencilAlt}
                                onClick={() => {
                                  setemergencyContact({
                                    ...emergencyContact,
                                    emergencyContactOne:
                                      settings?.emergencyContact1,
                                    emergencyContactTwo:
                                      settings?.emergencyContact2,
                                    emergencyContactThree:
                                      settings?.emergencyContact3,
                                  });
                                  setcompanySettingsEdit({
                                    ...companySettingsEdit,
                                    emergencyConatct: true,
                                  });
                                }}
                              />
                              <h2>Edit</h2>
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <div className="flex space-x-2">
                              <div className="sm:flex sm:space-x-6 space-y-3 sm:space-y-0">
                                <div>
                                  <input
                                    value={
                                      emergencyContact?.emergencyContactOne
                                    }
                                    onChange={(e) => {
                                      setemergencyContact({
                                        ...emergencyContact,
                                        emergencyContactOne: e.target.value,
                                      });
                                    }}
                                    className="border-b border-primary textField text-sm w-32"
                                    placeholder="Emergency Contact One"
                                  />
                                </div>
                                <div>
                                  <input
                                    value={
                                      emergencyContact?.emergencyContactTwo
                                    }
                                    onChange={(e) => {
                                      setemergencyContact({
                                        ...emergencyContact,
                                        emergencyContactTwo: e.target.value,
                                      });
                                    }}
                                    className="border-b border-primary textField text-sm w-32"
                                    placeholder="Emergency Contact Two"
                                  />
                                </div>
                                <div>
                                  <input
                                    value={
                                      emergencyContact?.emergencyContactThree
                                    }
                                    onChange={(e) => {
                                      setemergencyContact({
                                        ...emergencyContact,
                                        emergencyContactThree: e.target.value,
                                      });
                                    }}
                                    className="border-b border-primary textField text-sm w-32"
                                    placeholder="Emergency Contact three"
                                  />
                                </div>
                              </div>
                              <div className="flex space-x-5">
                                <FontAwesomeIcon
                                  className="cursor-pointer text-red-500"
                                  tool
                                  icon={faClose}
                                  onClick={() => {
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      emergencyConatct: false,
                                    });
                                  }}
                                />
                                <FontAwesomeIcon
                                  className="cursor-pointer text-green-600"
                                  icon={faSave}
                                  onClick={() => {
                                    dispatch({
                                      type: "UPDATE_SETTINGS",

                                      payload: {
                                        body: {
                                          emergencyContact1:
                                            emergencyContact?.emergencyContactOne,
                                          emergencyContact2:
                                            emergencyContact?.emergencyContactTwo,
                                          emergencyContact3:
                                            emergencyContact?.emergencyContactThree,
                                        },
                                      },
                                    });
                                    setcompanySettingsEdit({
                                      ...companySettingsEdit,
                                      emergencyConatct: false,
                                    });

                                    // window.location.reload();
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Settings);

export const SettingsItem = ({ icon, label, itemText }) => {
  return (
    <>
      <div className="mt-3 xs:mt-0 xs:flex items-center xs:space-x-2 space-y-1 xs:space-y-0">
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={icon} className="w-5 text-gray-400" />
          <div className="text-sm font-bold font-body">{label}: </div>
        </div>
        <div className="text-sm ml-7 font-body">{itemText}</div>
      </div>
    </>
  );
};
